import { NoValue } from 'components/no_value/NoValue';
import { ThemePickerDropdownItem } from 'components/top_bar/TopBarThemePicker';
import { useTheme } from 'contexts/ThemeContext';
import { Control, Controller } from 'react-hook-form';
import { ThemeType } from 'styles/colorMode';
import { usePendoTrackTheme } from 'styles/usePendoTrackTheme';

import {
    ProfileDropdownOption,
    ProfileItem,
    ProfileSettingDropdown,
    ProfileSubSection,
} from '../components';
import { UserSettingsFormData } from './UserProfileModal';

const themeOptions: ProfileDropdownOption<ThemeType>[] = [
    { Value: ThemeType.light, Text: 'Light' },
    { Value: ThemeType.darkOriginal, Text: 'Dark' },
    { Value: ThemeType.dark, Text: 'Navy' },
    { Value: ThemeType.night, Text: 'Night' },
];

export type AppearanceOption = 'theme';

type Props = Readonly<{
    control: Control<UserSettingsFormData>;
    allowedFeatures: Set<AppearanceOption>;
}>;

export function AppearanceSubSection({ control, allowedFeatures }: Props) {
    const { setColorMode, colorMode } = useTheme();
    const trackTheme = usePendoTrackTheme();

    if (allowedFeatures.size === 0) {
        return null;
    }

    return (
        <ProfileSubSection title="Appearance">
            {allowedFeatures.has('theme') && (
                <ProfileItem label="Color Theme">
                    <Controller
                        control={control}
                        name="colorMode"
                        render={({ field: { onChange, value } }) => (
                            <ProfileSettingDropdown
                                options={themeOptions}
                                value={
                                    themeOptions.find((o) => o.Value === value) ??
                                    themeOptions[0]
                                }
                                renderItem={(val) => (
                                    <ThemePickerDropdownItem item={val.item.Value} />
                                )}
                                renderLabel={(val) =>
                                    val.value ? (
                                        <ThemePickerDropdownItem item={val.value.Value} />
                                    ) : (
                                        <NoValue />
                                    )
                                }
                                onConfirm={(value) => {
                                    trackTheme(value.Value, colorMode, 'settings_modal');
                                    setColorMode(value.Value, {
                                        transient: true,
                                    });
                                    onChange(value.Value);
                                }}
                            />
                        )}
                    />
                </ProfileItem>
            )}
        </ProfileSubSection>
    );
}
